import { IconFileCertificate } from "@tabler/icons-react";
import { EPDSearchOUT } from "api-client";
import Badge from "components/Badge";
import Tooltip from "components/Tooltip";
import { getCurrentReferenceUnitValue } from "features/MappingEditor/utils";
import { useTranslation } from "react-i18next";

function EPDRow({ epd }: { epd: EPDSearchOUT }) {
  const { t, i18n } = useTranslation();
  const isEng = i18n.language === "en";

  const info = [
    {
      label: t("productEditor.conformity"),
      value: epd.conformity__name,
      tooltip: t("productEditor.conformityTooltip"),
    },
    {
      label: t("productEditor.EPDType"),
      value: t("EPDEditor.types." + epd.data_type),
    },
    {
      label: t("productEditor.manufacturer"),
      value: epd.manufacturer,
    },
    {
      label: t("productEditor.compatibilityWithCertifications"),
      value: epd.compliant_certifications
        ?.filter((c) => c != "Keine")
        .join(", "),
    },
  ];

  const refUnit = getCurrentReferenceUnitValue(epd.reference_unit);
  return (
    <div className="w-full">
      <div className="flex w-full justify-between">
        <p className="text-base font-semibold group-hover/listItem:text-indigo-900 transition">
          {epd.name_de}
        </p>
        <Badge type="auto" className="!max-w-fit !h-5" size="small">
          {isEng ? refUnit?.name : refUnit?.name_de}
        </Badge>
      </div>
      {epd.is_sentinel && (
        <div className="flex">
          <Tooltip content={t("providers.sentinelTooltip")}>
            <Badge type="success" className="!h-6 items-center mt-2">
              <IconFileCertificate
                className="w-4 h-4 text-green-600 mr-1"
                stroke={3}
              />
              {t("providers.sentinel")}
            </Badge>
          </Tooltip>
        </div>
      )}
      <div className="flex flex-wrap mt-2">
        {info
          .filter((rec) => rec.value)
          .map((key, index) => (
            <div className="mr-3 mb-1" key={index}>
              <label className="text-xs flex justify-between font-medium text-gray-800 items-center">
                {key.label}
                <span className="text-gray-500">
                  {key.tooltip && <Tooltip content={key.tooltip} />}
                </span>
              </label>
              <div className="text-xs font-normal pt-[2px] text-gray-500">
                {key.value}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}

export default EPDRow;
